<button mat-button color="primary" [routerLink]="buttonLink" (click)="action.emit()">
  <ng-content></ng-content><mat-icon iconPositionEnd>arrow_right</mat-icon>
</button>
